<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="proId"
      :columns="tableColumns"
      :queryParams="queryParams"
      :searchOptions="tableSearchOptions"
      :requestPromise="loadData?loadData:loadDataList"
    >
      <a-form-item slot="s1" label="自我游订单号" v-bind="searchItemLayout" style="margin-bottom: 0">
        <a-input v-model="queryParams.proName" placeholder="请输入自我游订单号" style="width: 100%"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="订单编号" v-bind="searchItemLayout" style="margin-bottom: 0">
        <a-input v-model="queryParams.proName" placeholder="请输入订单编号"  style="width: 100%"></a-input>
      </a-form-item>
      <a-form-item slot="s3" label="产品名称" v-bind="searchItemLayout" style="margin-bottom: 0">
        <a-input v-model="queryParams.proName" placeholder="请输入产品名称"  style="width: 100%"></a-input>
      </a-form-item>
      <a-form-item slot="s4" label="自我游类目" v-bind="searchItemLayout" style="margin-bottom: 0">
        <a-input v-model="queryParams.proName" placeholder="请选择自我游类目"  style="width: 100%"></a-input>
      </a-form-item>
      <a-form-item slot="s5" label="更新日期" v-bind="searchItemLayout" style="margin-bottom: 0">
        <a-input v-model="queryParams.proName" placeholder="请选择自我游类目"  style="width: 100%"></a-input>
      </a-form-item>
      <template v-slot:action="{record}">
        <a-space>
           <a @click="onSwitchStatus(record)">解除屏蔽</a>
        </a-space>
      </template>
    </StandardSearchPageView>
  </div>
</template>

<script>
import SearchMixins from '../../mixins/SearchMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import ZwyMiXins from '@/views/resource/zwy/mixins/ZwyMiXins'

export default {
  name: 'BlockingRecordComponent',
  mixins:[SearchMixins,ZwyMiXins],
  props:{
    proJoinType:{
      type:String,
      default:''
    },
    columns:{
      type:Array,
      default:()=>[]
    },
    searchOptions:{
      type:Array,
      default:()=>[]
    },
    loadData:{
      type:Function,
      default:undefined
    },
    // 首列/搜索项文案（自我游日历房传「酒店ID」）
    idLabel:{
      type:String,
      default:'自我游ID'
    },
    // 「商品信息」列文案（日历房传「酒店名称」）
    nameLabel:{
      type:String,
      default:'商品信息'
    },
    // 「商品名称」搜索项文案（日历房传「酒店名称」）
    searchNameLabel:{
      type:String,
      default:'商品名称'
    },
    // 酒店ID搜索入参字段名（日历房传 proProductUrl，其他页面用 productNo）
    idParamKey:{
      type:String,
      default:'productNo'
    },
    // 酒店名称搜索入参字段名（日历房传 proName，其他页面用 productName）
    nameParamKey:{
      type:String,
      default:'productName'
    }
  },
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {
      },
      localSearchOptions: [
        {
          name: this.idLabel,
          key: this.idParamKey,
          type: 'input',
          placeholder: `请输入${this.idLabel}`
        },
        {
          name: this.searchNameLabel,
          key: this.nameParamKey,
          type: 'input',
          placeholder: `请输入${this.searchNameLabel}`
        },
        // {
        //   name: '自我游类目',
        //   type: 'select',
        //   key: 'proJoinType',
        //   placeholder: '请选择',
        //   selectOptions: []
        // },
        {
          name: '屏蔽日期',
          key: 'startDate,endDate',
          type: 'rangePicker',
        },
      ],
    }
  },
  computed:{
    tableColumns(){
      return this.columns&&this.columns.length>0?this.columns:this.getColumns()
    },
    tableSearchOptions(){
      return this.searchOptions&&this.searchOptions.length>0?this.searchOptions:this.localSearchOptions
    }
  },
  methods: {
    loadDataList(params) {
      const requestParams = this.getRequestParams(params)
      requestParams.proJoinType=this.proJoinType;
      return this.getHttpServices().getSourceService().post('zwy/combo/shieldRecord',requestParams)
    },
    getColumns(){
      return [
        {
          title: this.idLabel,
          dataIndex: 'productNo',
          width: '100px'
        },
        {
          title: this.nameLabel,
          dataIndex: 'proName',
          width: '420px',
        },
        {
          title: '屏蔽时间',
          dataIndex: 'proShieldTime',
          width: '160px',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    onSwitchStatus(item){
      const url='/zwy/combo/shield'
      this.requestGet(url,{proId:item.proId},()=>this.$refs.table.refresh(false))
    },

  }
}
</script>

<style scoped></style>
